import { h, Component } from 'preact';
import { condClass, joinClasses } from 'utils/utils';
import s from 'components/shared/simpleVideoPlayer/playerControls.sss';

let fullscreenPrefixes = [
	{ enabled: 'fullscreenEnabled', event: 'fullscreenchange', element: 'fullscreenElement', request: 'requestFullscreen', exit: 'requestFullscreen' },
	{ enabled: 'webkitFullscreenEnabled', event: 'webkitfullscreenchange', element: 'webkitFullscreenElement', request: 'webkitRequestFullscreen', exit: 'webkitExitFullscreen' },
	{ enabled: 'mozFullScreenEnabled', event: 'mozfullscreenchange', element: 'mozFullscreenElement', request: 'mozRequestFullScreen', exit: 'mozCancelFullScreen' },
	{ enabled: 'msFullscreenEnabled', event: 'msfullscreenchange', element: 'msFullscreenElement', request: 'msRequestFullscreen', exit: 'msExitFullscreen' },
];
const fullscreen = typeof document !== 'undefined' && fullscreenPrefixes.find(fs => document[fs.enabled]);

export default class PlayerControls extends Component {

	constructor() {
		super();
		this.state.fullScreen = false;

		this.toggleParentFullScreen = this.toggleParentFullScreen.bind(this);
		this.fullscreenChanged = this.fullscreenChanged.bind(this);
		this.openCaptionsMenu = this.openCaptionsMenu.bind(this);
		this.toggleSingleCaption = this.toggleSingleCaption.bind(this);
	}

	componentDidMount() {
		if (fullscreen) {
			document.addEventListener(fullscreen.event, this.fullscreenChanged);
		}
	}

	componentWillUnmount() {
		if (fullscreen) {
			document.removeEventListener(fullscreen.event, this.fullscreenChanged);
		}
	}

	openCaptionsMenu() {
		this.setState({ captionsMenuOpen: true });
	}

	closeCaptionsMenu() {
		this.setState({ captionsMenuOpen: false });
	}

	fullscreenChanged() {
		if (!fullscreen) {
			return;
		}
		this.setState({ fullScreen: !!document[fullscreen.element] });
	}

	toggleParentFullScreen(videoEl) {
		const goFullScreen = !this.state.fullScreen;
		if (typeof this.props.enforceFullScreen === 'function') {
			this.props.enforceFullScreen(goFullScreen);
		}
		if (!fullscreen) {
			return;
		}

		if (goFullScreen) {
			videoEl = videoEl || this.props.containerRef || this.$container.parentElement;
			if (typeof videoEl[fullscreen.request] === 'function') {
				videoEl[fullscreen.request]();
			}
		} else {
			if (typeof document[fullscreen.exit] === 'function') {
				document[fullscreen.exit]();
			}
		}
	}

	updateProgress = (event) => {
		const boundingRect = this.$progress.getBoundingClientRect();
		// get the click position where 0 is the the start of the progress bar
		const newProgressPos = event.pageX - boundingRect.left;
		// get the width of the full progress bar, (use bounding client rect because offsetWidth doesn't think about transform scale)
		const progressWidth = boundingRect.width;
		const percentage = newProgressPos / progressWidth;
		const newTime = percentage * this.props.duration;
		// Set the new time as the progress
		this.props.setProgress(newTime);
	};

	handleMenuButton(index) {
		this.props.activeCaptionIndex === index ? this.props.setActiveCaptionIndex() : this.props.setActiveCaptionIndex(index);
		this.closeCaptionsMenu();
	}

	// if there is only one captions track in the list
	toggleSingleCaption() {
		this.props.activeCaptionIndex === 0 ? this.props.setActiveCaptionIndex() : this.props.setActiveCaptionIndex(0);
	}

	renderCaptionsMenu(captions) {
		if (!captions || !captions.length) {
			return;
		}
		return (
			<div
				class={joinClasses({
					s,
					captionsMenu: true,
					captionsMenuShow: this.state.captionsMenuOpen
				})}
			>
				<button
					class={this.props.activeCaptionIndex === undefined && s.activeCaption}
					key="off"
					onClick={() => this.handleMenuButton()}
				>
					Off
				</button>
				{captions.map((c, i) => (
					<button
						class={this.props.activeCaptionIndex === i && s.activeCaption}
						key={c.label}
						onClick={() => this.handleMenuButton(i)}
					>
						{c.label}
					</button>
				))}
			</div>
		);
	}

	render() {
		const {
			playing, // is the video playing
			togglePlay, // callback to toggle playing
			duration, // total duration of the video,
			progress, // current progress of the video
			muted, // is the video muted
			toggleMute, // callback to toggle mute
			activeCaptionIndex,
			captions,
			passedClass, // styling class passed down if needed
			passedStyle, // styling values passed down if needed
			containerClass, // styling class passed down for the container if needed
			containerStyle, // styling values passed down for the container if needed
			playButtonClass, // styling class passed down for the play button if needed
			tabIndex = '0'
		} = this.props;

		const progressStyle = {};
		// Set the width to the right percentage
		const transformStyle = `scaleX(${progress / duration})`;
		progressStyle.transform = transformStyle;
		progressStyle.webkitTransform = transformStyle;

		let fullScreenSupported = !!fullscreen;
		let isFullScreen = this.props.fullScreen === undefined ? this.state.fullScreen : this.props.fullScreen;

		return (
			<div ref={$ref => this.$container = $ref} class={containerClass} style={containerStyle}>
				<div class={s.bigPlayBtn + condClass(playing, s.hidden) + condClass(playButtonClass)} onClick={togglePlay} />
				<div class={s.controls + condClass(passedClass)} style={passedStyle}>
					<button class={playing ? s.playPlaying : s.playPaused} onClick={togglePlay} tabIndex={tabIndex} />
					<div
						class={s.progressBar}
						onClick={this.updateProgress}
						tabIndex={tabIndex}
						ref={$ref => this.$progress = $ref}
					>
						<div class={s.progress} style={progressStyle} />
					</div>
					<button class={muted ? s.muted : s.mute} onClick={toggleMute} tabIndex={tabIndex} />
					{(captions && captions.length > 0) && (
						<button
							class={activeCaptionIndex !== undefined ? s.disableCaptions : s.enableCaptions}
							onClick={captions.length === 1 ? this.toggleSingleCaption : this.openCaptionsMenu}
							tabIndex={tabIndex}
						/>
					)}
					{fullScreenSupported && (
						<button
							class={isFullScreen ? s.exitFullScreen : s.fullScreen}
							onClick={this.toggleParentFullScreen}
							tabIndex={tabIndex}
						/>
					)}
					{this.renderCaptionsMenu(captions)}
				</div>
			</div>
		);
	}

}
